// import LoomPlayer from 'react-loom-player';
import { useEffect, useRef } from 'react';
import ReactPlayer from 'react-player';

export default function LoomPlayer() {
  const loomVideoUrl = "https://www.loom.com/share/d36d470fc4f049c7ac9c9a93c7d3a927?sid=e851e4de-2d42-4de6-a5c8-c1248f714095";
  
 
  return (
    <div ><iframe src="https://www.loom.com/embed/d36d470fc4f049c7ac9c9a93c7d3a927?sid=954441a2-7bba-41c8-a9b3-337bbc413b52" ></iframe></div>
  )
}
